import { render, staticRenderFns } from "./planTrip.vue?vue&type=template&id=137484ce&scoped=true&"
import script from "./planTrip.vue?vue&type=script&lang=js&"
export * from "./planTrip.vue?vue&type=script&lang=js&"
import style0 from "./planTrip.vue?vue&type=style&index=0&id=137484ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137484ce",
  null
  
)

export default component.exports